import useBodyClasses from '@/hooks/useBodyClasses';
import { toAbsoluteUrl } from '@/utils';
import { Link } from 'react-router-dom';
import { Fragment } from 'react/jsx-runtime';
const Error403Page = () => {
  useBodyClasses('dark:bg-coal-500');
  return <Fragment>
      {/* <div className="mb-10">
        <img src={toAbsoluteUrl('/media/illustrations/22.svg')} className="dark:hidden max-h-[160px]" alt="image" />
        <img src={toAbsoluteUrl('/media/illustrations/22-dark.svg')} className="light:hidden max-h-[160px]" alt="image" />
      </div> */}

      <span className="badge badge-primary badge-outline mb-3">403 Error</span>

      <h3 className="text-2.5xl font-semibold text-gray-900 text-center mb-2">
        Forbidden Access
      </h3>

      <div className="text-md text-center text-gray-700 mb-10">
        You don't have permission to access this page. Please try again later
      </div>

      <Link to="/" className="btn btn-primary flex justify-center">
        Back to Home
      </Link>
    </Fragment>;
};
export { Error403Page };